import axios from "axios";

const login = axios.create({
    baseURL: `${process.env.REACT_APP_LOGIN_CHECK}`
})

async function ServLoginCheck() {
    const response = await login.get('');
    return response
}

export {
    ServLoginCheck
}